import { LoadableComponent } from 'common/components';
import { BlockedAppScreenComponent } from 'common/components/blocked-app-screen';
import { useLanguages } from 'core/hooks/languages';
import { i18n, resolveSupported } from 'core/i18n';
import { useSettings } from 'core/hooks/settings';
import React, { PropsWithChildren, useEffect, useState } from 'react';

export const AppSettingsGuardComponent: React.FC<PropsWithChildren> = ({ children }) => {
  const { settings, isSettingsLoading, isSettingsError } = useSettings();
  const { isFetched: isLanguageCatalogReady } = useLanguages();
  const [isLanguageApplied, setIsLanguageApplied] = useState(false);

  const preferredLanguage = settings?.userPreferences?.language;

  useEffect(() => {
    if (!isLanguageCatalogReady || isSettingsLoading) {
      return;
    }

    let active = true;
    void i18n.changeLanguage(resolveSupported(preferredLanguage ?? i18n.language)).finally(() => {
      if (active) {
        setIsLanguageApplied(true);
      }
    });
    return () => {
      active = false;
    };
  }, [preferredLanguage, isLanguageCatalogReady, isSettingsLoading]);

  const isWaitingForLanguage = !isLanguageApplied;

  return (
    <LoadableComponent isLoading={isSettingsLoading} isError={isSettingsError}>
      {settings?.appSettings?.allowActions ? (
        <LoadableComponent isLoading={isWaitingForLanguage}>{children}</LoadableComponent>
      ) : (
        <BlockedAppScreenComponent />
      )}
    </LoadableComponent>
  );
};
